import { ReactNode, useEffect } from "react";
import { useAPI } from "../api/useAPI";
import { useBehaviorSubjectState } from "../utils/useBehaviorSubjectState";
import { Capacitor } from "@capacitor/core";
import { YouthCampAppPlugin } from "../capacitor/plugins";
import { Platform } from "common";
import { useStore } from "../store/StoreProvider";

interface AppRootProps {
  children: ReactNode;
}

export const AppRoot = ({ children }: AppRootProps) => {
  const api = useAPI();
  const [isLoggedIn] = useBehaviorSubjectState(api.isLoggedIn$);
  const { setState } = useStore();

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }
    if (Capacitor.getPlatform() === "ios") {
      YouthCampAppPlugin.addListener("deviceToken", (resp) => {
        api.accountDeviceTokenPost({
          token: (resp as any)["token"],
          platform: Platform.IOS,
        });
      });
      YouthCampAppPlugin.registerPushNotifications();
    }
    api.activityGet({}).then((response) => {
      setState((s) => ({ ...s, activityList: response.activities }));
    });
  }, [api, isLoggedIn, setState]);

  return <>{children}</>;
};
